<style scoped lang="scss" type="text/scss">
    .present-container {
        margin: -1rem 0 0 -1rem;
        display: flex;
        flex-wrap: wrap;

        .present-item {
            margin: 1rem 0 0 1rem;
        }

        .placeholder {
            margin: 1rem 0 0 1rem;
        }
    }
</style>

<template>
    <div class="present-container">
        <present-item class="present-item" v-for="(item, index) in presents" :key="index"
                      :info="item" :index="index + 1"
        >
        </present-item>
        <placeholder v-if="presents.length === 0" class="placeholder">
            未填写到场情况
        </placeholder>
    </div>
</template>

<script>
    import PresentItem from '../present-item';
    import Placeholder from '@/components/placeholder/index';
    import _ from 'lodash';

    export default {
        name: '',
        props: {
            data: {
                type: Object,
                default: () => {
                    return {};
                }
            }
        },
        components: {
            PresentItem,
            Placeholder
        },
        computed: {
            presents () {
                if (this.data === null) return [];
                return [
                    {
                        name: '男教师人数',
                        number: _.get(this.data, 'male_teachers_number', 0)
                    },
                    {
                        name: '女教师人数',
                        number: _.get(this.data, 'female_teachers_number', 0)
                    },
                    {
                        name: '男学生人数',
                        number: _.get(this.data, 'male_students_number', 0)
                    },
                    {
                        name: '女学生人数',
                        number: _.get(this.data, 'female_students_number', 0)
                    }
                ];
            }
        },
        data () {
            return {};
        }
    };
</script>
